import {types} from './types';

const initialState = {
    list: {
        count: 1,
        list: []
    },
    view: {
        result: [],
        allPage: 1,
    },
    login: ''
}

export function dailyReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST:
            return { ...state, list: action.payload};
        case types.SET_VIEW:
            return { ...state, view: action.payload};
        case types.SET_LOGIN:
            return { ...state, login: action.payload};
        default:
            return state
    }
}